<div *ngIf="!displayMobileView" [ngClass]="{'content-table-pointer': customData === 'row-pointer'}">
  <ion-row class="PC-row content gray-md-rows black" (click)="edit()">
    <ion-col size="6">{{ row.name }}</ion-col>
    <ion-col size="6">{{ row.description }}</ion-col>
    <ion-col size="2">
      <div class="ion-text-center">
        <ion-button type="close" size="medium" (click)="delete($event)">
          <ion-icon name="close" size="medium"></ion-icon>
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
</div>

<div *ngIf="displayMobileView" class="company-department" (click)="edit()">
  <div>
    <div class="company-department__row">
      <ion-label class="company-department__title">{{
        "NAME" | translate
      }}</ion-label>
      <ion-label class="company-department__content">
        {{ row.name }}
      </ion-label>
    </div>
    <div *ngIf="row.description" class="company-department__row">
      <ion-label class="company-department__title">{{
        "DESCRIPTION" | translate
      }}</ion-label>
      <ion-label class="company-department__content">
        {{ row.description }}
      </ion-label>
    </div>
  </div>
  <ion-button fill="clear" size="small" (click)="delete($event)">
    <ion-icon name="close-outline" slot="icon-only"></ion-icon>
  </ion-button>
</div>
